/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom"
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie } from 'recharts';

export default class ClaimStatusChart extends BaseCom {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }

  componentDidMount() {
    qreq.get('/api/chart/claim/breakdown?type=' + this.props.type, j => {
      if (j.list) {
        var total = 0;
        j.list.forEach(i => {
          total += i.dv;
          i.fill = i.fillColor;
        });
        this.setState({ data: j.list, total: total });
        if (j.list.length === 0)
          this.props.onNoData?.();
      }
    });
  }

  render() {
    return <ResponsiveContainer width="100%" height={400}>
      <PieChart
        width={500}
        height={300}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <Tooltip content={a => a && <div className="bg-light border border-dark p-3">
          {a.payload && a.payload.length > 0 && <div style={{ color: a.payload[0].payload.fill }}>
            <div>{a.payload[0].name}</div>
            <div>{this.props.type === 'amount' ? Globals.formatCurrency(a.payload && a.payload.length > 0 ? a.payload[0].value : 0) : (a.payload && a.payload.length > 0 ? a.payload[0].value : 0)}</div>
            <div>{Math.round((a.payload[0].value / this.state.total) * 10000) / 100} %</div>
          </div>}
        </div>} />
        <Legend />
        <Pie data={this.state.data} type="monotone" dataKey="dv" nameKey="name" stroke="#828aca" fillOpacity={1} label={props => {
          const { name, value, x, y, fill } = props;
          let formatted = value;
          if (this.props.type === 'amount') formatted = Globals.formatCurrency(value);

          const text = String(formatted);

          const padding = 6;
          const fontSize = 12;
          const textWidth = text.length * (fontSize * 0.6);
          const textHeight = fontSize + 4;
          return (
            <g transform={`translate(${x}, ${y})`}>

              <rect
                x={-textWidth / 2 - padding}
                y={-textHeight / 2 - padding}
                width={textWidth + padding * 2}
                height={textHeight + padding * 2}
                fill="white"
                stroke={fill}
                strokeWidth="1"
                rx="4"
                ry="4"
              />

              <text
                fill={fill}
                fontSize={fontSize}
                textAnchor="middle"
                dominantBaseline="central"
              >
                {text}
              </text>
            </g>
          );
        }} />
      </PieChart>
    </ResponsiveContainer>;
  }
}